/**
 * Logarithmic estimation score for Crowflight R4. See spec §8.3.
 * Symmetric in over- and under-estimation (ratio-based, not absolute).
 */
export function scoreLogDistanceGuess(guessKm, truthKm) {
    const ratio = Math.abs(Math.log10(guessKm / truthKm));
    const raw = 100 * Math.max(0, 1 - ratio / 0.7);
    return Math.round(raw);
}
//# sourceMappingURL=logDistanceScore.js.map